import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { Richtext } from 'dhx-richtext';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MailFieldsService } from '../../Master/mailfields/mailfields.service';
import { MailTemplateService } from './mailtemplate.service';
import { MailTemplate } from './mailtemplate';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { UserService } from '../../Master/user/user.service';
import { MailgroupService } from '../../mailgroup/mailgroup.service';
import { HelpdeskComponent } from '../../Shared/helpdesk/helpdesk.component';
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';
declare var $: any;

@Component({
  selector: 'app-mailtemplate',
  templateUrl: './mailtemplate.component.html',
  styleUrls: ['./mailtemplate.component.css'],
  providers: [MailFieldsService, ToastrService, MailTemplateService]
})
export class MailtemplateComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Mail Template';
  //form action rights
  _actionRights: any;
  _menuId: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  public richtext: any; public _metaFieldsList: any; action: string; _mailTemplateId: any;
  _metaFieldsListSelect: any;
  _mailTempList: any;
  _mailTempListactive: any = [];
  _mailGroupListtmp: any = []; _mailGroupList: any = []; _selectedItems: any = []; _dropdownSettings: any; _groupMapped: any = []; _toMailIdMapped: any[]; _ccMailIdMapped: any[]; userid: number; postresult: boolean; confmsg: string;
  p: number = 1; public searchText: string;
  //_userMailList: any = [];
  _selectedToIds: any = []; _selectedCcIds: any = []; _toMailDropdownSettings: any; _userMailList: any = []; _toMailList: any = []; _ccMailList: any = []; editorclick: boolean; msg: string; _clickEvent: string;
  itemsPerPage: number = 10;
  textBoxTocuhed: boolean;
  currenttemplate: string;
  isDisabledContent: boolean = true;
  showall: boolean = true;
  showallstatus: boolean = false;
  focusinto: boolean = false;
  focusincc: boolean = false;
  isRichTextBoxReq=true;
  constructor(private MailFields: MailFieldsService,
    private toastr: ToastrService, private router: Router,
    private formBuilder: FormBuilder,
    private mailTemplateSer: MailTemplateService, private dialogService: DialogService,
    private userService: UserService, private mailgroupService: MailgroupService,
    private localService: LocalService) {
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('MailTemplate_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('MailTemplate_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('MailTemplate_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('MailTemplate_action');
    }}

  //formgroup
  mailtemplateForm: FormGroup;
  mailTemps: MailTemplate[];
  mailTemp: MailTemplate;
  submitted = false;  
  
  ngOnInit() {
    this.checkIsMenuMapped();
    //form validation   
    this.mailtemplateForm = this.formBuilder.group(
      {
        templatename: ['', Validators.required],
        mailgroup: [''],
        subject: ['', Validators.required],
        tomailid: [''], ccmailid: [''],
        externalto: [''], externalcc: ['']
        
      });
    this.Loadmailgrouplist();
    this.Loadusermaillist();
    this.LoadMailTemplateList();
    this.Loadmailfieldsvaluelist();
    this.searchText = '';
    this.action = 'add';
    this._mailTemplateId = '';
    this._selectedItems = [];
    this._mailTempList = [];
    this._selectedToIds = [];
    this._selectedCcIds = [];
    this.currenttemplate = '';
    this.textBoxTocuhed = false;

    //form action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();

    //$('body').addClass('nav-sm').removeClass('nav-md');
  }


  key: string = 'templatename'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedmailtemplate");
    let data = arrays.find(ob => ob['name'] === 'Mail Template');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedmailtemplate","true");
      this.isRichTextBoxReq=false;
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.isRichTextBoxReq=false;
      this.localService.setJsonValue("notauthorizedmailtemplate",null);
      this.router.navigate(["home"]);      
    }
  }

  getActionRightsList() {
 
   // if(this._actionRights != null && this._actionRights !=undefined){
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
 // }
  }
  get formdata() { return this.mailtemplateForm.controls; }
  //load the meta fields value details in the list from services
  Loadmailfieldsvaluelist() {
    this.MailFields.Get().subscribe(res => {
      //console.log(res);
      this._metaFieldsList = res;
     
      
      if(this.isRichTextBoxReq!=false){
      this.LoadRichtextBox();
      }
    }, error => { this.toastr.error('Error while getting the mail fields data') });
  }

  //load the mail group name in the dropdown
  Loadmailgrouplist() {

    this.mailgroupService.getmailgroups().subscribe(res => {
      if (res != undefined) {
        //console.log(res);
        var allData = res;
        allData.forEach(data => {
          if (data.active != 0) {
            this._mailGroupListtmp.push({ mailgroupid: data.mailgroupid, mailgroup: data.mailgroup });
          }
        });
        this._dropdownSettings = {
          singleSelection: false,
          idField: 'mailgroupid',
          textField: 'mailgroup',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true
        };
        this._mailGroupList = JSON.parse(JSON.stringify(this._mailGroupListtmp));
      }
    }, error => { this.toastr.error('Error in getting group mail list'); }

    )


  };
  //to get the individual user mail list 
  Loadusermaillist() {
    let a= new encryptdecrypt(); 
    this.userService.Get().subscribe(
      res => {
      res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
         
        var allData = res;
        allData.forEach(data => {
          if (data.active != 0) {
            this._userMailList.push({ userid: data.userid, emailid: data.emailid });
          }
        });
        this._toMailDropdownSettings = {
          singleSelection: false,
          idField: 'userid',
          textField: 'emailid',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true,
          enableCheckAll: true
        };
        this._toMailList = JSON.parse(JSON.stringify(this._userMailList));
        this._ccMailList = JSON.parse(JSON.stringify(this._userMailList));
      }, error => { this.toastr.error('Error in getting user mail list'); }
    )
  }
  onItemSelect(item: any) {
    this.textBoxTocuhed = true;
  }


  onCCmailidSelect(item: any) {
    this.textBoxTocuhed = true;
  }

  mailAddressValidation(arr1, aar2, txt, item, controlName) {
    if (arr1.lenth != 0) {
      arr1.forEach(data => {
        if (data.userid == item.userid) {
          this.toastr.error(item.emailid + ' already mapped in ' + txt + ' address');
          aar2.splice(aar2.findIndex(e => e.userid === item.userid), 1);
          this.mailtemplateForm.controls[controlName].setValue(aar2);
          return;
        }
      });
    }
  }

  onItemDeSelect(item: any) {
    //console.log(item);
    this.textBoxTocuhed = true;
  }

  LoadRichtextBox() {
    this.richtext = new Richtext("richtext_container", {
      mode: "classic", toolbarBlocks: ["default"]
    });
    this.richtext.toolbar.data.remove("link");
    this._metaFieldsListSelect = this._metaFieldsList.filter(item => item.type == 1);
    for (var i = 0; i < this._metaFieldsListSelect.length; i++) {
      var _value = this._metaFieldsListSelect[i]['mailfields'];
      var _id = this._metaFieldsListSelect[i]['mailfieldsvalues'];
      this.richtext.toolbar.data.add(
        {
          type: "button",
          value: _value,
          id: _id
        }, i + 24);
    }
    var EditorAPI = this.richtext.getEditorAPI();
    this.richtext.toolbar.events.on("click", function (id, event) {
      //console.log(EditorAPI.getModel());
      if (id.startsWith('$$')) {
        // EditorAPI.add(id);
        EditorAPI.add(' ' + id + ' ');
      }
      event.preventDefault();
    });
    this.richtext.toolbar.events.on('selectionRefresh', function (event) {
      event.preventDefault();
    });

  }
  //load existing mail template list
  LoadMailTemplateList() {
    this._mailTempList = [];
    this._mailTempListactive = [];
    this.mailTemplateSer.Get().subscribe(
      (res) => {
        if (res != undefined) {
          //console.log(res);
          this.mailTemps = res;
          this._mailTempList = [];
          this.mailTemps.forEach(item => {
            if (item.mailtemplateid != 0) {
              this._mailTempList.push({
                mailtemplateid: item.mailtemplateid,
                templatename: item.templatename,
                deletetemplate: item.deletetemplate,
                active: item.active

              });
            }
          });
          if (this.showallstatus == true) {
            this._mailTempList.forEach(data => {
              if (data.active == 1) {
                this._mailTempListactive.push(data);
              }
            });
            this._mailTempList = [];
            this._mailTempList = this._mailTempListactive;
          }
        }
      }, error => { this.toastr.error('Error in getting mail template data'); });
  }
  getactiveinactive(showallp) {
    this._mailTempListactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this._mailTempList.forEach(data => {
        if (data.active == 1) {
          this._mailTempListactive.push(data);
        }
      });
      this._mailTempList = [];
      this._mailTempList = this._mailTempListactive;
    }
    else {
      this.showall = true;
      this._mailTempList = [];
      this.LoadMailTemplateList();
    }
  }

  //saving the mail template details in to the db
  saveTemplate(operation) {
    var _groupText = {}; var _mailToIds = {}; var _mailCcIds = {};
    this.submitted = true;
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    var validmailContentTxt = this.richtext.getValue("markdown");

    var mailContentTxt = this.richtext.getValue("html");
    if (this.mailtemplateForm.valid) {

      if (this.mailtemplateForm.value.templatename.trim() == null || this.mailtemplateForm.value.templatename.trim() == '') {
        this.toastr.warning('Mail template should not be empty');
        return;
      }
      if (this.mailtemplateForm.value.subject.trim() == null || this.mailtemplateForm.value.subject.trim() == '') {
        this.toastr.error('Subject should not be empty');
        return;
      }

      if ((mailContentTxt.trim() == undefined) || (mailContentTxt.trim() == '') || (mailContentTxt.trim() == '<p></p>') || (validmailContentTxt.trim() == '')) {
        this.toastr.error('Mail content should not be empty');
        return;
      }

      if (((this._selectedItems == null) || (this._selectedItems.length == 0)) && ((this._selectedToIds.length == null) || (this._selectedToIds.length == 0))
        && ((this._selectedCcIds.length == null) || (this._selectedCcIds.length == 0))) {
        this.toastr.error('Atleast any one mail address should get selected');
        return;
      }
      _groupText['mailgroups'] = this.mailSaveStructure(this._selectedItems, 'mailgroup'); //this._selectedItems 
      _mailToIds['mailto'] = this.mailSaveStructure(this._selectedToIds, 'user'); //this._selectedToIds;
      _mailCcIds['mailcc'] = this.mailSaveStructure(this._selectedCcIds, 'user');//this._selectedCcIds;
      this._groupMapped = []; this._toMailIdMapped = []; this._ccMailIdMapped = [];
      //console.log(JSON.stringify(_groupText));
      // console.log(_groupText);
      

      //if (this.mailtemplateForm.value.externalto.trim() != null && this.mailtemplateForm.value.externalto.trim() !== '' &&
      //  this.mailtemplateForm.value.externalcc.trim() != null && this.mailtemplateForm.value.externalcc.trim() !== '') {
        var externalToList = [], validmailid: boolean = true; var externalCcList = []
        var regxpat = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        if (this.mailtemplateForm.value.externalto) {
          if (this.mailtemplateForm.value.externalto.trim() != null && this.mailtemplateForm.value.externalto.trim() !== '') {
            //var externalToList = [], validmailid: boolean = true
            let a = this.mailtemplateForm.value.externalto.split(';')
            a.forEach(data => {
              if (!regxpat.test(data)) {
                this.toastr.warning('Please enter valid External TO Mail id instead of ' + data)
                validmailid = false
                //return;
              }
              else {
                externalToList.push(data)
                validmailid = true
              }
            })
            if (!validmailid) {
              //this.toastr.warning('please enter valid Mail id ')
              return
            }
          }
        }
        if (this.mailtemplateForm.value.externalcc) {
          if (this.mailtemplateForm.value.externalcc.trim() != null && this.mailtemplateForm.value.externalcc.trim() !== '') {
            // var regxpat = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
            let b = this.mailtemplateForm.value.externalcc.split(';')
            b.forEach(data => {
              if (!regxpat.test(data)) {
                this.toastr.warning('Please enter valid  External CC Mail id instead of ' + data)
                validmailid = false
                // throw ('');
                //return;
              }
              else {
                externalCcList.push(data);
                validmailid = true;
              }
            })
            if (!validmailid) {
              //this.toastr.warning('please enter valid Mail id ')
              return
            }
          }
        }
        //var externalToList = [], validmailid: boolean = true

        //var regxpat = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        //let a = this.mailtemplateForm.value.externalto.split(';')
        //a.forEach(data => {


        //  if (!regxpat.test(data)) {
        //    this.toastr.warning('please enter valid External TO Mail id instead of ' + data)
        //    validmailid = false
        //    //return;
        //  }
        //  else {
        //    externalToList.push(data)
        //    validmailid = true
        //  }

        //})
        //var externalCcList = []
        //let b = this.mailtemplateForm.value.externalcc.split(';')
        //b.forEach(data => {
        //  if (!regxpat.test(data)) {
        //    this.toastr.warning('please enter valid  External CC Mail id instead of ' + data)
        //    validmailid = false
        //    // throw ('');
        //    //return;
        //  }
        //  else {
        //    externalCcList.push(data);
        //    validmailid = true;
        //  }

        //})
        //if (!validmailid) {
        //  //this.toastr.warning('please enter valid Mail id ')
        //  return
        //}

    //  }
      this.mailtemplateForm.value.externalto = JSON.stringify(externalToList);
      this.mailtemplateForm.value.externalcc = JSON.stringify(externalCcList);


      this.mailtemplateForm.value.groupmapped = JSON.stringify(_groupText);
      this.mailtemplateForm.value.mailto = JSON.stringify(_mailToIds);
      this.mailtemplateForm.value.mailcc = JSON.stringify(_mailCcIds);
      this.mailtemplateForm.value.mailcontent = mailContentTxt;
      if ((mailContentTxt.trim() != undefined) || (mailContentTxt.trim() != '')) {
        if (operation == 'add') {
          this.mailtemplateForm.value.active = 1;
          this.mailtemplateForm.value.createdby = this.userid;
          this.mailTemplateSer.Post(this.mailtemplateForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success('Data added successfully');
                this.LoadMailTemplateList();
                this.clearForm();
              }
              else { this.toastr.warning('Mail Template exists already'); }

            }, error => { this.toastr.error(error); });
        }
        if (operation == 'update') {
          this.mailtemplateForm.value.modifiedby = this.userid;
          this.mailtemplateForm.value.mailtemplateid = this._mailTemplateId;
          this.mailTemplateSer.Put(this.mailtemplateForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success('Data updated successfully');
                this.LoadMailTemplateList();
                this.clearForm();
              }
              else { this.toastr.error('Mail Template exists already'); }
            }, error => {
              //console.log(error);
              this.toastr.error(error);
            });
        }
      }
      else {
        this.toastr.error('Mail content should not be empty');
      }
    }
  }

  mailSaveStructure(list, type) {
    var temp = [];
    if (type == 'mailgroup') {
      if ((list != null) && (list.length > 0)) {
        list.forEach(item => {
          temp.push({ mailgroupid: item.mailgroupid })
        })
      }
    }
    if (type == 'user') {
      if ((list != null) && (list.length > 0)) {
        list.forEach(item => {
          temp.push({ userid: item.userid })
        })
      }
    }
    return temp;
  }
 

  touched() {
    this.textBoxTocuhed = true;
  }
  confirmation(mailtemplateid, templatename, action) {
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Confirmation',
        message: 'Would you like to save changes? ' + this.currenttemplate,
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.saveTemplate(action);
        }
        else {
          this.mailtemplateForm.markAsUntouched();
          this.textBoxTocuhed = false;
          this.currenttemplate = '';
          this.edittemplate(mailtemplateid, templatename, action);
        }
      });

  }
  clearForm() {
    this.submitted = false;
    this.action = 'add';
    this._selectedItems = [];
    this._selectedToIds = [];
    this._selectedCcIds = [];
    this.mailtemplateForm.controls['tomailid'].setValue(this._selectedToIds);
    this.mailtemplateForm.controls['ccmailid'].setValue(this._selectedCcIds);
    this.mailtemplateForm.controls['mailgroup'].setValue(this._selectedItems);
    this.mailtemplateForm.controls['externalto'].setValue('');
    this.mailtemplateForm.controls['externalto'].setValue('');
    this.mailtemplateForm.reset();
    this.richtext.setValue('');
    this.currenttemplate = '';
    this.textBoxTocuhed = false;
  }
  //click event for edit icon in the grid
  edittemplate(mailtemplateid, templatename, action) {
    this.submitShow = true;
    if ((this.currenttemplate != '') && ((this.textBoxTocuhed == true) || (this.mailtemplateForm.touched == true) || (this.mailtemplateForm.controls['tomailid'].touched == true)
      ||
      (this.mailtemplateForm.controls['ccmailid'].touched == true) || (this.mailtemplateForm.controls['mailgroup'].touched == true))) {
      if (action != 'view')
        this.confirmation(mailtemplateid, templatename, action);
    }
    else {
      if (action == 'view')
        this.isDisabledContent = false;
      this.mailtemplateForm.value.mailtemplateid = mailtemplateid;
      this.currenttemplate = templatename;
      this.textBoxTocuhed = false;
      this.mailtemplateForm.value.templatename = null;
      //this.mailtemplateForm.value.active = 1;
      this.mailTemplateSer.Getbyinfo(this.mailtemplateForm.value).subscribe(
        (res) => {
          if (res != undefined) {
            //console.log(res.body[0].groupmapped);
            if (JSON.parse(res.body[0].groupmapped) != null) {
              this._selectedItems = this.formMultiSelectStrucuture((JSON.parse(res.body[0].groupmapped)).mailgroups, this._mailGroupListtmp, 'mailgroup');
              //this._selectedItems = (JSON.parse(res.body[0].groupmapped)).mailgroups;
            }
            else
              this._selectedItems = [];
            if (JSON.parse(res.body[0].mailto) != null)
              this._selectedToIds = this.formMultiSelectStrucuture((JSON.parse(res.body[0].mailto)).mailto, this._userMailList, 'user');
            //(JSON.parse(res.body[0].mailto)).mailto;
            else
              this._selectedToIds = [];
            if (JSON.parse(res.body[0].mailcc) != null)
              this._selectedCcIds = this.formMultiSelectStrucuture((JSON.parse(res.body[0].mailcc)).mailcc, this._userMailList, 'user');
            //(JSON.parse(res.body[0].mailcc)).mailcc;
            else
              this._selectedCcIds = [];

            var externalTolist = JSON.parse(res.body[0].externalto);
            //this.getemailstring(externalTolist)
            var externalCclist = JSON.parse(res.body[0].externalcc);
            this.mailtemplateForm.controls['externalto'].setValue(this.getemailstring(externalTolist));
            this.mailtemplateForm.controls['externalcc'].setValue(this.getemailstring(externalCclist));


            this.mailtemplateForm.controls['templatename'].setValue(res.body[0].templatename);
            this.richtext.setValue(res.body[0].mailcontent);
            this.mailtemplateForm.controls['subject'].setValue(res.body[0].subject);
            this.action = action;
            this._mailTemplateId = res.body[0].mailtemplateid;
          }
        }, error => {
          //console.log(error);
        })
    }
  }


  //form valid mail structure suit for  multi select list
  formMultiSelectStrucuture(mappedList, mailList, type) {
    var tempList = [];
    if (type == 'mailgroup') {
      if ((mappedList != null) && (mappedList.length != 0)) {
        mailList.forEach((d) => {
          mappedList.forEach((data, ind) => {
            if (data.mailgroupid == d.mailgroupid) {
              tempList.push({
                mailgroupid: d.mailgroupid, mailgroup: d.mailgroup
              });
            }
          });
        });
      }
    }
    if (type == 'user') {
      if ((mappedList != null) && (mappedList.length != 0)) {
        mailList.forEach((d) => {
          mappedList.forEach((data, ind) => {
            if (data.userid == d.userid) {
              tempList.push({
                userid: d.userid, emailid: d.emailid
              });
            }
          });
        });
      }
    }
    mappedList = [];
    mappedList = tempList;
    return tempList;
  }


  //function to activate or deactivate the mail template
  statusChange(id, option) {
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    if (option == 'activate') {
      this.confmsg = "activate";
      this.mailtemplateForm.value.active = 1;
      this.msg = "Record activated successfully";
    }
    else {
      this.confmsg = "deactivate";
      this.mailtemplateForm.value.active = 0;
      this.msg = "Record deactivated successfully";
    }
    this.mailtemplateForm.value.mailtemplateid = id;
    this.mailtemplateForm.value.modifiedby = this.userid;
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true

      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.mailTemplateSer.Delete(this.mailtemplateForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success(this.msg);
                this.LoadMailTemplateList();
              }
            }, error => {
              //console.log(error);
              this.toastr.error(error);
            });
        }
      });
  }
  getemailstring(externallist) {
    if (externallist) {
      var externalToliststr = '';
      externallist.forEach((d) => {
        if (externalToliststr == '')
          externalToliststr = d;
        else
          externalToliststr = externalToliststr + ';' + d;
      });
    }
    return externalToliststr
  }

}
